<template>
  <div>
    <table-with-search
      :items="models"
      :headers="allHeaders"
      :openDialog="openDialog"
      @headersUpdated="updateHeaders"
      @refreshItems="refreshItems"
      :showRefresh="true"
    />
    <v-dialog
      v-model="openForm"
      max-width="550px"
      persistent
      @keydown.esc="reset(false)"
    >
      <Form
        @save="saveForm"
        @cancel="reset"
        :maxWidth="maxWidth"
        :mode="mode"
        :show="true"
        :showCheck="true"
        :itemsSelect="dataSelected"
        :showDate="true"
        :key="keyForm"
      >
      </Form>
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
  </div>
</template>
<script>
import groups from "../../../store/groups/groups";
import TableWithSearch from "../../Complement/TableWithSearch.vue";
import models from "../../../store/groups/model";
import Snackbar from "../../Complement/Snackbar.vue";
import Form from "../../Complement/Form.vue";
import concepts from "../../../store/conceptos/concepts";
import date from "../../../store/common/date";
import DeleteDialog from "../../Complement/DeleteDialog.vue";
import moment from "moment";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: { TableWithSearch, Snackbar, Form, DeleteDialog },
  data() {
    return {
      titleTable: "Grupos_Modelos",
      headers: [
        {
          text: "Modelo",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      openForm: false,
      alert: false,
      textAlert: "No se ha seleccionado un grupo",
      color: null,
      maxWidth: "550px",
      titleDelete: this.$tc("groups.toModel"),
      itemToDelete: null,
      itemsToEdit: null,
      type: null,
      keyForm: 0,
    };
  },
  async mounted() {
    await concepts.dispatch("getLiquidationModels");
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },
  watch: {
    dataSelected: {
      handler(newVal, oldVal) {
        // console.log("old", oldVal[0].data);
        // console.log("nw", newVal[0].data);
      },
      deep: true,
    },
  },
  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    models() {
      return models.state.models;
    },
    title() {
      return groups.state.itemSelected.son;
    },
    dataSelected() {
      return [
        {
          name: "models",
          label: this.$tc("groups.models"),
          data: [],
          items: this.modelsSelect,
          itemsValue: "liqmodelId",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          readonly: false,
        },
      ];
    },

    mode: {
      get() {
        return models.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    allModels() {
      return concepts.state.liquidations;
    },
    modelsSelect() {
      return concepts.state.liquidations.filter(
        (model) =>
          !models.state.models.some(
            (selected) => selected.id === model.liqmodelId
          )
      );
    },
    openDelete: {
      get() {
        return models.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },

  methods: {
    async refreshItems() {
      if (groups.state.itemSelected.id) {
        const groupId = groups.state.itemSelected.id;
        await models.dispatch("getModels", groupId);
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },

    openDialog(type, item) {
      this.type = type;

      switch (this.type) {
        case "add":
          this.keyForm++;
          if (this.validGroup()) {
            this.dataSelected[0].items = this.modelsSelect;
            models.commit("setOpenModels", true);
            this.openForm = true;
            models.commit("setMode", this.$tc("groups.addModelTitle"));
          }
          break;
        case "edit":
          this.keyForm++;
          this.seteoItems(item);

          break;
        case "delete":
          models.commit("setOpenDelete", true);
          this.itemToDelete = item;
          break;
        default:
          break;
      }
    },
    async seteoItems(item) {
      this.dataSelected[0].items = await this.allModels;
      models.commit("setOpenModels", true);
      this.openForm = true;
      models.commit("setMode", this.$tc("groups.editModelTitle"));
      this.itemsToEdit = item;
      this.dataSelected[0].data = item.id;
      this.dataSelected[0].readonly = true;
      date.commit("setDateFrom", this.formatDate(item.from));
      date.commit("setDateTo", item.to == "" ? null : this.formatDate(item.to));
      date.commit("setCheckTo", item.to == "" ? true : false);
    },

    formatDate(item) {
      const dateToFormat = moment(item, "DD-MM-YYYY");
      let date = dateToFormat.format("YYYY-MM-DD");
      return date;
    },
    validGroup() {
      if (groups.state.itemSelected.son) {
        return true;
      } else {
        this.showAlert(
          (this.textAlert = this.$tc("groups.selectGroup")),
          "error"
        );
        return false;
      }
    },
    reset(value) {
      this.resetDate();
      models.commit("setOpenModels", value);
      this.openForm = value;
      this.alert = false;
      this.dataSelected.forEach((item) => {
        item.data = "";
        item.readonly = false;
      });
    },
    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },
    saveForm(value) {
      let id = parseInt(value.models, 10);
      const payload = {
        from: date.state.dateFrom,
        to: date.state.dateTo,
        id: id,
        name: this.getName(id),
        groupId: groups.state.itemSelected.id,
      };
      switch (this.type) {
        case "add":
          this.isAdd(payload);
          break;
        case "edit":
          this.isEdit(payload);
          break;

        default:
          break;
      }
    },
    isAdd(payload) {
      models.commit("setNew", payload);
      models
        .dispatch("new")
        .then(() => {
          this.showAlert(
            (this.textAlert = this.$tc("groups.addModel")),
            "primary"
          );
        })
        .catch((e) => {
          this.showAlert(
            (this.textAlert = this.$tc("groups.errorModel")),
            "error"
          );
        });
      this.reset(false);
    },
    isEdit(payload) {
      let payloadEdit = {
        ...payload,
        oldFrom: this.itemsToEdit.from,
      };
      models.commit("setEdit", payloadEdit);
      models
        .dispatch("edit")
        .then(() => {
          this.showAlert(
            (this.textAlert = this.$tc("groups.editModel")),
            "primary"
          );
        })
        .catch((e) => {
          this.showAlert(
            (this.textAlert = this.$tc("groups.errorEditModel")),
            "error"
          );
        });
      this.reset(false);
    },
    getName(id) {
      const models = concepts.state.liquidations.find(
        (emp) => emp.liqmodelId === id
      );
      return models.name;
    },
    deleteItem() {
      models.commit("setDeleteItem", this.itemToDelete);
      models
        .dispatch("delete")
        .then(() => {
          models.commit("setOpenDelete", false);
          this.showAlert(
            (this.textAlert = this.$tc("groups.deleteModel")),
            "primary"
          );
        })
        .catch((e) => {
          this.showAlert(this.$tc("groups.errorDeleteModel"), "error");
        });
    },
    cancelDelete() {
      models.commit("setOpenDelete", false);
      holidays.commit("setOpenDelete", false);
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
  },
};
</script>
<style scoped></style>
